import React from 'react';
import LoadingCell from '../loadingCell/loadingCell';

import './textCell.scss';

const TextCell = (props) => {
  if (props.rowType === "groupHeader") {
    return null;
  }

  if (props.dataItem[props.field] === undefined && props.treelist) return <td></td>;
  if (props.dataItem[props.field] === undefined && props.grid) return <td></td>;
  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  return (
    <td style={props.style} className={props.className}>
      {props.field.startsWith('measure') ? (
        <div className="text-cell alignment-right">{props.dataItem[props.field]}</div>
      ) : (
        <div className="text-cell" title={props.useTooltip ? props.dataItem[props.field] : ''}>{props.dataItem[props.field]}</div>
      )}
    </td>
  );
};

export default TextCell;
